module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingListPage"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼の一覧ページ")]), _vm._v(" "), _c('h2', [_vm._v("以下の授業振替依頼が届いております。依頼を承諾または拒否してください")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8de6e8da", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8de6e8da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/ReschedulingListPage.vue
// module id = 738
// module chunks = 0